/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class HelpManualAPI extends ApiClient {
  constructor() {
    super('help_manual', { accountScoped: true });
  }

  createCopy(name) {
    return axios.post(`${this.url}/copies`, { name });
  }

  getArticle(articleKey, locale) {
    return axios.get(`${this.url}/articles/${encodeURIComponent(articleKey)}`, {
      params: { locale },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  submitArticleFeedback(portalSlug, articleSlug, feedback) {
    return axios.post(
      `/hc/${encodeURIComponent(portalSlug)}/articles/${encodeURIComponent(articleSlug)}/feedback.json`,
      { feedback }
    );
  }

  getUpdates(helpManualId) {
    return axios.get(`${this.url}/copies/${helpManualId}/updates`);
  }

  applyArticleUpdate(helpManualId, articleKey, locale) {
    return axios.patch(
      `${this.url}/copies/${helpManualId}/articles/${encodeURIComponent(articleKey)}`,
      { locale }
    );
  }

  selectContextualManual(helpManualId) {
    return axios.patch(`${this.url}/contextual_portal`, {
      help_manual_id: helpManualId,
    });
  }
}

export default new HelpManualAPI();
